import { render, staticRenderFns } from "./CreatePreservation.vue?vue&type=template&id=0407417c&"
import script from "./CreatePreservation.vue?vue&type=script&lang=ts&"
export * from "./CreatePreservation.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePreservation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports